import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore }                   from '@/store/user';

import _import               from './import';
import qs                    from 'qs';
import { PermissionManager } from '@/utils/permissions/permissionManager';

const router = createRouter({
  history : createWebHistory(import.meta.env.BASE_URL),
  parseQuery(query) {

    return qs.parse(query);
  },
  stringifyQuery(query) {

    return qs.stringify(query);
  },
  routes : [
    {
      path      : '/:catchAll(.*)',
      name      : '404',
      component : _import('error/404')
    },
    {
      path      : '/tenant/:tenant/login/google',
      name      : 'login-google',
      component : _import('login/index')
    },
    {
      path      : '/tenant/:tenant/login/azure',
      name      : 'login-azure',
      component : _import('login/index')
    },
    {
      path      : '/tenant/:tenant/login',
      name      : 'login',
      component : _import('login/index')
    },
    {
      path      : '/tenant/:tenant/logout',
      name      : 'logout',
      component : _import('logout/index')
    },
    {
      path      : '/tenant/:tenant/access-denied',
      name      : 'access-denied',
      component : _import('access-denied/index')
    },
    {
      path      : '/tenant/:tenant/notifications',
      name      : 'notifications',
      component : _import('notifications/index')
    },
    {
      path     : '/tenant/:tenant/',
      name     : 'home',
      redirect : (to) => {

        return {
          name   : 'folders',
          params : to.params
        };
      }
    },
    // {
    //   path      : '/tenant/:tenant/dashboard',
    //   name      : 'dashboard',
    //   component : _import('dashboard/index')
    // },
    {
      path      : '/tenant/:tenant/my-business',
      name      : 'my-business',
      component : _import('my-business/index')
    },
    {
      path     : '/tenant/:tenant/classeurs',
      name     : 'classeurs',
      redirect : to => {

        return {
          name   : 'classeurs-list',
          params : to.params
        };
      },
      children : [
        {
          name      : 'classeurs-list',
          path      : '/tenant/:tenant/classeurs',
          component : _import('classeurs/index')
        },
        {
          name      : 'classeur-empty',
          path      : '/tenant/:tenant/classeurs/:classeurId',
          component : _import('classeurs/details')
        },
        {
          name      : 'classeur-details-folder',
          path      : '/tenant/:tenant/classeurs/:classeurId/dossier/:folderId',
          component : _import('classeurs/details'),
          redirect  : to => {

            return {
              name   : 'classeur-details-folder-information',
              params : to.params
            };
          },
          children  : [
            {
              name      : 'classeur-details-folder-information',
              path      : 'information',
              component : _import('folders/tabs/FolderTabInfo')
            }, {
              name      : 'classeur-details-folder-notaries',
              path      : 'notaries',
              component : _import('folders/tabs/FolderTabNotaries')
            }, {
              name      : 'classeur-details-folder-charges-partners',
              path      : 'charges-partners',
              component : _import('folders/tabs/FolderTabChargesPartners')
            }, {
              name      : 'classeur-details-folder-tasks',
              path      : 'tasks',
              component : _import('folders/tabs/FolderTabTasks'),
              props     : true
            }, {
              name      : 'classeur-details-folder-documents',
              path      : 'documents',
              component : _import('folders/tabs/FolderTabDocuments')
            }, {
              name      : 'classeur-details-folder-checklist',
              path      : 'checklist',
              component : _import('folders/tabs/FolderTabChecklist')
            }, {
              name      : 'classeur-details-folder-commissions',
              path      : 'commissions',
              component : _import('folders/tabs/FolderTabCommissions')
            }, {
              name      : 'classeur-details-folder-sandbox',
              path      : 'sandbox',
              component : _import('folders/tabs/FolderTabSandbox')
            }, {
              name      : 'classeur-details-folder-alerts',
              path      : 'alerts',
              component : _import('folders/tabs/FolderTabAlerts')
            }, {
              name      : 'classeur-details-folder-invoices',
              path      : 'invoices',
              component : _import('folders/tabs/FolderTabInvoices')
            }
          ]
        }
      ]
    },
    {
      path     : '/tenant/:tenant/dossiers',
      name     : 'folders',
      redirect : to => {

        return {
          name   : 'folders-list',
          params : to.params
        };
      },
      children : [
        {
          name      : 'folders-list',
          path      : '/tenant/:tenant/dossiers',
          component : _import('folders/index')
        }, {
          name      : 'folders-create',
          path      : '/tenant/:tenant/dossiers/add/:property?/:mandates*?/:offer?',
          component : _import('folders/create'),
          meta      : { permissionElement : PermissionManager.permissionElement.dossiers.actions.create },
          props     : true
        }, {
          name      : 'folders-create-vefa',
          path      : '/tenant/:tenant/dossiers/add/:contract?/:program?/:lot?/:booking?',
          component : _import('folders/create'),
          meta      : { permissionElement : PermissionManager.permissionElement.dossiers.actions.create },
          props     : true
        }, {
          name      : 'folder-details',
          path      : '/tenant/:tenant/dossiers/:folderId',
          component : _import('folders/details'),
          redirect  : to => {

            return {
              name   : 'folder-details-information',
              params : to.params
            };
          },
          children  : [
            {
              name      : 'folder-details-information',
              path      : 'information',
              component : _import('folders/tabs/FolderTabInfo')
            }, {
              name      : 'folder-details-notaries',
              path      : 'notaries',
              component : _import('folders/tabs/FolderTabNotaries')
            }, {
              name      : 'folder-details-charges-partners',
              path      : 'charges-partners',
              component : _import('folders/tabs/FolderTabChargesPartners'),
              meta      : { }
            }, {
              name      : 'folder-details-tasks',
              path      : 'tasks',
              component : _import('folders/tabs/FolderTabTasks'),
              props     : true
            }, {
              name      : 'folder-details-checklist',
              path      : 'checklist',
              component : _import('folders/tabs/FolderTabChecklist')
            }, {
              name      : 'folder-details-documents',
              path      : 'documents',
              component : _import('folders/tabs/FolderTabDocuments'),
              meta      : { }
            }, {
              name      : 'folder-details-commissions',
              path      : 'commissions',
              component : _import('folders/tabs/FolderTabCommissions'),
              meta      : { }
            }, {
              name      : 'folder-details-sandbox',
              path      : 'sandbox',
              component : _import('folders/tabs/FolderTabSandbox')
            }, {
              name      : 'folder-details-alerts',
              path      : 'alerts',
              component : _import('folders/tabs/FolderTabAlerts')
            }, {
              name      : 'folder-details-invoices',
              path      : 'invoices',
              component : _import('folders/tabs/FolderTabInvoices')
            }
          ]
        }
      ]
    },
    {
      path     : '/tenant/:tenant/notaries',
      name     : 'notaries',
      redirect : to => {

        return {
          name   : 'notaries-list',
          params : to.params
        };
      },
      children : [
        {
          name      : 'notaries-list',
          path      : '/tenant/:tenant/notaries',
          component : _import('notaries/index')
        }, {
          name      : 'clerks-list',
          path      : '/tenant/:tenant/clerks',
          component : _import('clerks/index'),
          props     : true
        }
      ]
    },
    {
      path      : '/tenant/:tenant/tasks',
      name      : 'tasks-list',
      component : _import('tasks/index')
    },
    {
      path      : '/tenant/:tenant/proformas',
      name      : 'proformas-list',
      component : _import('proformas/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.proforma.show }
    },
    {
      path      : '/tenant/:tenant/folders-to-calculate',
      name      : 'folders-to-calculate',
      component : _import('folders-to-calculate/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.proforma.showProformasToInvoice }
    },
    {
      path      : '/tenant/:tenant/issuedInvoices',
      name      : 'issued-invoices-list',
      component : _import('issued-invoices/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.invoice.show }
    },
    {
      path      : '/tenant/:tenant/incomingInvoices',
      name      : 'incoming-invoices-list',
      component : _import('incoming-invoices/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.invoice.show }
    },
    {
      path      : '/tenant/:tenant/invoices-to-be-created',
      name      : 'third-party-invoices-to-be-created-list',
      component : _import('third-party-invoices-to-be-created/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.thirdPartyInvoice.showInvoicesToBeCreated }
    },
    {
      path      : '/tenant/:tenant/offers',
      name      : 'offers-list',
      component : _import('offers/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.offer.show }
    },
    {
      path      : '/tenant/:tenant/bookings',
      name      : 'bookings-list',
      component : _import('bookings/index'),
      meta      : { permissionElement : PermissionManager.permissionElement.offer.show }
    },
    {
      path      : '/tenant/:tenant/admin',
      name      : 'admin',
      component : _import('admin/index'),
      meta      : {
        permissionElement : PermissionManager.permissionElement.admin.show
      },
      redirect  : to => {

        if (PermissionManager.getPermissionForElement(PermissionManager.permissionElement.admin.relations)) {
          return {
            name   : 'admin-users-relations',
            params : to.params
          };
        }

        if (PermissionManager.getPermissionForElement(PermissionManager.permissionElement.admin.banks)) {
          return {
            name   : 'admin-bank-accounts',
            params : to.params
          };
        }

        if (PermissionManager.getPermissionForElement(PermissionManager.permissionElement.admin.taskTemplates)) {
          return {
            name   : 'admin-task-templates',
            params : to.params
          };
        }
      },
      children  : [
        {
          name      : 'admin-users-relations',
          path      : '/tenant/:tenant/admin/users-relations',
          component : _import('admin/users-relations/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
        }, {
          name      : 'admin-users-relations-details',
          path      : '/tenant/:tenant/admin/users-relations/:id',
          component : _import('admin/users-relations/details'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.relations },
          redirect  : to => {

            return {
              name   : 'admin-users-relations-details-commissioning-schemas',
              params : to.params
            };
          },
          children  : [
            {
              name      : 'admin-users-relations-details-commissioning-schemas',
              path      : '/tenant/:tenant/admin/users-relations/:id/commissioning-schemas',
              component : _import('admin/users-relations/tabs/UserTabCommissioningSchema'),
              meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
            },
            {
              name      : 'admin-users-relations-details-relations',
              path      : '/tenant/:tenant/admin/users-relations/:id/relations',
              component : _import('admin/users-relations/tabs/UserTabRelations'),
              meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
            },
            {
              name      : 'admin-users-relations-details-overrides',
              path      : '/tenant/:tenant/admin/users-relations/:id/overrides',
              component : _import('admin/users-relations/tabs/UserTabOverrides'),
              meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
            },
            {
              name      : 'admin-users-relations-details-exceptions',
              path      : '/tenant/:tenant/admin/users-relations/:id/exceptions',
              component : _import('admin/users-relations/tabs/UserTabExceptions'),
              meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
            },
            {
              name      : 'admin-users-relations-details-sales-history',
              path      : '/tenant/:tenant/admin/users-relations/:id/sales-history',
              component : _import('admin/users-relations/tabs/UserTabSalesHistory'),
              meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
            }
          ]
        }, {
          name      : 'admin-users-relations-details-contract',
          path      : '/tenant/:tenant/admin/users-relations/:id/contract',
          component : _import('admin/users-relations/contract'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.relations }
        }, {
          name      : 'admin-bank-accounts',
          path      : '/tenant/:tenant/admin/bank-accounts',
          component : _import('admin/bank-accounts/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.banks }
        }, {
          name      : 'admin-partners',
          path      : '/tenant/:tenant/admin/partners',
          component : _import('admin/partners/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.partners }
        }, {
          name      : 'admin-partners-create',
          path      : '/tenant/:tenant/admin/partners/add',
          component : _import('admin/partners/create'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.partners }
        }, {
          name      : 'admin-partners-details',
          path      : '/tenant/:tenant/admin/partners/:id',
          component : _import('admin/partners/details'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.partners }
        }, {
          name      : 'admin-task-templates',
          path      : '/tenant/:tenant/admin/task-templates',
          component : _import('admin/task-templates/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.taskTemplates }
        }, {
          name      : 'admin-task-templates-create',
          path      : '/tenant/:tenant/admin/task-templates/add',
          component : _import('admin/task-templates/form'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.taskTemplates }
        }, {
          name      : 'admin-task-templates-details',
          path      : '/tenant/:tenant/admin/task-templates/:id',
          component : _import('admin/task-templates/form'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.taskTemplates }
        }, {
          name      : 'admin-proforma-agent-template',
          path      : '/tenant/:tenant/admin/proforma-agent-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.proformaTemplates }
        }, {
          name      : 'admin-proforma-manual-template',
          path      : '/tenant/:tenant/admin/proforma-manual-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.proformaTemplates }
        }, {
          name      : 'admin-proforma-partner-template',
          path      : '/tenant/:tenant/admin/proforma-partner-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.proformaTemplates }
        }, {
          name      : 'admin-notary-invoice',
          path      : '/tenant/:tenant/admin/notary-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.notaryTemplates }
        }, {
          name      : 'admin-third-party-invoice-mail-template',
          path      : '/tenant/:tenant/admin/third-party-invoice-mail-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.notaryTemplates }
        }, {
          name      : 'admin-upload-link-mail-template',
          path      : '/tenant/:tenant/admin/admin-upload-link-mail-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.linkTemplates }
        }, {
          name      : 'admin-download-link-mail-template',
          path      : '/tenant/:tenant/admin/admin-download-link-mail-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.linkTemplates }
        }, {
          name      : 'admin-other-invoice',
          path      : '/tenant/:tenant/admin/other-template',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.notaryTemplates }
        },
        {
          name      : 'admin-permissions-override',
          path      : '/tenant/:tenant/admin/permissions-override',
          component : _import('admin/permissions/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.permissions }
        },
        {
          name      : 'admin-dossier-cover',
          path      : '/tenant/:tenant/admin/dossier-cover',
          component : _import('admin/template-editor/index'),
          meta      : { permissionElement : PermissionManager.permissionElement.admin.notaryTemplates }
        }
      ]
    }
  ]
});

router.beforeEach((to) => {

  const store = useUserStore();

  if (store.navigationLocked) {

    store.setShowNavigationAlert(true);

    setTimeout(() => {

      store.setShowNavigationAlert(false);
    }, 2000);

    return false;
  }

  const tenant = to.params?.tenant ? to.params?.tenant : store.tenant;

  if (!to.params?.tenant && tenant && tenant !== '') {
    to.params.tenant = tenant;
  }

  //Redirige au login si l'utilisateur n'est pas connecté
  //Doit passer avant le check des permissions : sinon un utilisateur déconnecté part sur la home et l'url demandée est perdue.
  if (store.token === '' && (!to?.name || !to.name.startsWith('login') && !to.name.startsWith('logout'))) {
    store.setRedirectUrl(to);
    return { name : 'login', params : { tenant } };
  }

  // Redirige vers la home si l'utilisateur n'a pas les droits spécifiques pour la route
  if ('permissionElement' in to.meta) {

    if (!PermissionManager.getPermissionForElement(to.meta.permissionElement)) {

      return { name : 'home', params : { tenant } };
    }
  }

  //Redirige a la home si l'utilisateur est connecté et essaye d'aller sur la page de login
  if (store.token !== '' && to.name === 'login') {
    return { name : 'home', params : { tenant } };
  }

  return true;
});

export default router;
